/* ConfigDrift.js */

"use strict";
const Registrations = require("../../RegistrationNamespaces");

module.exports = {
    name: "config_drift",
    label: "Config Drift and Audit",
    disabled: false,
    order: 3, // Deprecated -- Newer solution uses order from index.js
    app: "GameConsole",
    section: "GameCenter",
    license: ["CDA", "GLUWARE"],
    accessPerm: ["configDriftAndAuditAccess"],
    pageTitle: "Gluware Config Drift and Audit",
    helpLink: "Config%20Drift%20and%20Audit/Track-device-configurations.htm",
    navIcon: "cda.solution",
    iconName: "branding.configDrift",
    lmrbNamespaces: [
        Registrations.CONFIG_DRIFT_DEVICE_EXPLORER_ENTITY_LMRB,
        Registrations.AUDIT_POLICY_EXPLORER_LMRB,
    ],
    editorNamespaces: [Registrations.DEVICE_INSTANCE_EDITOR],
    auditPolicyExplorer: {
        viewNamespaces: [
            Registrations.AUDIT_POLICY_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
            Registrations.AUDIT_POLICY_EXPLORER_GRID,
        ],
        actionNamespaces: [
            Registrations.AUDIT_POLICY_EXPLORER_ACTION_CREATE,
            Registrations.AUDIT_POLICY_EXPLORER_ACTION_CLONE,
            Registrations.AUDIT_POLICY_EXPLORER_ACTION_IMPORT,
            Registrations.AUDIT_POLICY_EXPLORER_ACTION_EXPORT,
            Registrations.AUDIT_POLICY_EXPLORER_ACTION_DELETE,
        ],
    },
    auditPolicyEditor: {
        viewNamespaces: [
            Registrations.AUDIT_POLICY_EDITOR_VIEW_DETAILS,
            Registrations.AUDIT_POLICY_EDITOR_VIEW_RESULTS,
            Registrations.AUDIT_POLICY_EDITOR_VIEW_HISTORY,
            Registrations.AUDIT_POLICY_EDITOR_VIEW_VERSIONS,
            Registrations.AUDIT_POLICY_EDITOR_VIEW_ACTIVITY,
        ],
        actionNamespaces: [Registrations.AUDIT_POLICY_EDITOR_ACTIONS_GLOB],
    },
    deviceExplorer: {
        viewNamespaces: [
            Registrations.CONFIG_AUDIT_DEVICE_VIEW_GRID,
            Registrations.DEVICE_EXPLORER_SWITCH_TO_AUDIT_POLICY,
        ],
        actionNamespaces: [
            Registrations.DEVICE_EXPLORER_ACTION_CAPTURE,
            Registrations.DEVICE_EXPLORER_ACTION_SET_DEFAULT_CONFIG,
            Registrations.DEVICE_EXPLORER_ACTION_REPORT,
            Registrations.DEVICE_EXPLORER_ACTION_CONFIGURE_AUDIT,
            Registrations.DEVICE_EXPLORER_ACTION_ADHOC_QUERY,
            Registrations.DEVICE_EXPLORER_ACTION_EXPORT,
            Registrations.DEVICE_EXPLORER_ACTION_BACKUP,
            Registrations.DEVICE_EXPLORER_ACTION_RESTORE,
            Registrations.DEVICE_EXPLORER_ACTION_LINK_AND_SYNC,
        ],
    },
    deviceEditor: {
        viewNamespaces: [
            Registrations.DIE_VIEW_DETAILS,
            Registrations.DIE_VIEW_SNAPSHOT,
            Registrations.DIE_VIEW_CONFIG,
            Registrations.DIE_VIEW_ACTIVITY,
            Registrations.DIE_VIEW_COMPARE,
            Registrations.DIE_VIEW_AUDIT_SUMMARY,
            Registrations.DIE_VIEW_RESTORE,
            // Registrations.DIE_VIEWS_GLOB
        ],
        actionNamespaces: [
            Registrations.DIE_ACTION_CONFIG_AUDIT,
            Registrations.DIE_ACTION_CAPTURE,
            Registrations.DIE_ACTION_BACKUP,
            Registrations.DIE_ACTION_SET_DEFAULT_CONFIG,
        ],
    },
    navOptions: {
        device: {
            name: "Devices",
            options: {
                exp: "device",
            },
            type: "exp",
        },
        config_drift: {
            name: "Audit Policies",
            options: {
                exp: "audit",
            },
            type: "exp",
        },
    },
};
